var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.loading && _vm.$auth.isAuthenticated)?_c('LoggedInStart'):_c('LoggedOutStart')}
var staticRenderFns = []

export { render, staticRenderFns }